<template>
<!-- 复用组件 itemTable 的弹出窗 编辑 新增都是它 -->
<div>
  <el-dialog :title="temp.name" :visible.sync="dialog.dialogFormVisible" width="35%" append-to-body >
    <el-form :model="temp" label-position="right" label-width="100px" class="dialog-form" :rules="rules" ref="form">
      <el-form-item label="公式名称" prop="name" >
        <el-input v-model="temp.name"></el-input>
      </el-form-item>
      <el-form-item label="公式类型" prop="type">
        <el-select v-model="temp.type">
          <el-option label="计算值" value="calculation" key="calculation"></el-option>
          <el-option label="输入值" value="inputValue" key="inputValue"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="公式分组">
        <!-- <el-input v-model="temp.virtualGroup"></el-input> -->
        <el-select v-model="temp.virtualGroup" multiple filterable allow-create placeholder="可手动输入" @change="selectChange">
          <el-option v-for="(item, index) of groupOption" :key="index" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="单位" prop="unit">
        <el-input v-model="temp.unit"></el-input>
      </el-form-item>
      <el-form-item label="公式编号" prop="serialNumber">
        <el-input v-model="temp.serialNumber" placeholder="公式编号需要以一位字母开头，后接数字"></el-input>
      </el-form-item>
      <!-- <el-form-item label="公式类型">
        <el-select v-model="temp.virtualType">
          <el-option label="计算值" value="CALCULATION_VALUE"></el-option>
          <el-option label="输入值" value="INPUT_VALUE"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" plain :disabled="!readyForSubmit" @click="saveInfo">保存</el-button>
        <!-- <el-button type="primary" plain @click="$emit('Save')">保存</el-button> -->
        <el-button @click="dialog.dialogFormVisible = false">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'dialogs',
  props: [
    'temp',
    'dialog',
    'API',
    'titleVerify',
    'groupOptions',
    'originalList'
  ],
  data () {
    const checkNameInuse = (rules, value, cb) => {
      let inUse = 0
      for (const item of this.originalList) {
        if (value.trim() === item.name) {
          if (!this.temp.id) {
            inUse++
          } else if (this.temp.id.id !== item.id.id) {
            inUse++
            // cb()
          }
        }
      }
      if (inUse > 0) {
        cb(new Error('name in use'))
      } else {
        cb()
      }
    }
    const checkSerialInuse = (rules, value, cb) => {
      let inUse = 0
      for (const item of this.originalList) {
        if (value === item.serialNumber) {
          if (this.temp.id && this.temp.id.id !== item.id.id) {
            inUse++
          } else if (!this.temp.id) {
            inUse++
            // cb()
          }
        }
      }
      if (inUse > 0) {
        cb(new Error('name in use'))
      } else {
        cb()
      }
    }
    const checkSerial = (rules, value, cb) => {
      const meterRegex = /^[a-zA-Z](\d)+$/
      console.log(meterRegex.test(value))
      if (meterRegex.test(value)) {
        console.log('legal')
        cb()
      } else {
        console.log('no!!!')
        cb(new Error('ilegal'))
      }
    }
    const checkName = (rules, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('不可为空，请输入'))
      } else {
        callback()
      }
    }
    return {
      groupOption: [],
      routerMenuLabel: [],
      rules: {
        name: [
          { required: true, message: '请输入公式名称', trigger: 'blur' },
          { validator: checkNameInuse, message: '名称重复', trigger: 'blur' },
          { min: 1, max: 25, message: '名称长度在1-25个字符之间', trigger: 'blur' },
          { validator: checkName, trigger: 'blur' }
        ],
        unit: [
          { required: true, message: '请输入公式单位 ', trigger: 'blur' },
          { validator: checkName, trigger: 'blur' }
        ],
        serialNumber: [
          { required: true, message: '请输入公式编号，以一位字母开头，后接数字', trigger: 'blur' },
          { validator: checkSerialInuse, message: '公式编号重复', trigger: 'blur' },
          { validator: checkSerial, message: '公式编号需要以一位字母开头，后接数字', trigger: 'blur' }
        ],
        type: { required: true, message: '请选择公式类型', trigger: 'blur' }
      }
    }
  },
  methods: {
    itemFilter (index) {
      const rules = [
        'id',
        'additionalInfo',
        'tenantId',
        'customerId',
        'authority'
      ]
      if (!rules.includes(index)) {
        return true
      } else {
        return false
      }
    },
    selectChange () {
      // console.log(this.temp.virtualGroup, '----change')
      let index = -1
      let valid = false
      for (const item of this.temp.virtualGroup) {
        index++
        if (item.trim() === '') {
          valid = true
          this.$message.error('字符不可为空，请输入')
          break
        }
      }
      if (this.temp.virtualGroup.length > 0) {
        this.temp.virtualGroup.forEach(item => {
          item = item.trim()
        })
      }
      if (valid) {
        this.temp.virtualGroup.splice(index, 1)
      }
    },
    saveInfo () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialog.dialogFormVisible = false
          this.temp.virtualGroup = this.temp.virtualGroup.map(item => item.trim())
          this.$emit('Save')
        } else {
          this.$message('请完善表单')
        }
      })
      // this.dialog.dialogFormVisible = false
      // this.$emit('Save')
    },
    filterMenu (data, mName, mName2) {
      for (const item of data) {
        if (item.name === mName[0] || item.label === mName[1]) {
          this.routerMenuLabel.push(item.label)
        }
        if (mName2 && (item.name === mName2[0] || item.label === mName2[1])) {
          this.routerMenuLabel.push(item.label)
        }
      }
    }
  },
  computed: {
    readyForSubmit () {
      if (this.temp.name && this.temp.unit && this.temp.serialNumber) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    // console.log(this.groupOptions, this.temp, this.temp.virtualGroup, '-----g')
    // if (!this.temp.type) {
    //   this.temp.type = 'calculation'
    // }
    // if (!this.temp.virtualGroup) {
    //   console.log(2222)
    //   this.temp.virtualGroup = []
    //   this.temp.virtualGroup.push('定额设置')
    // }
    // 生产管理： '产量录入', '单耗分析',  绩效：'定额设置',  统计报表：'用能统计' 现在的 数据报表
    // for (const item of this.$store.state.permission.routers) {
    //   if (item.name === 'productionManage' || item.label === '生产管理') {
    //     this.filterMenu(item.children, ['unitConsumptionAnalysis', '单耗分析'], ['productionEntry', '产量录入'])
    //   }
    //   if (item.name === 'performanceAppraisal' || item.label === '绩效考核') {
    //     this.filterMenu(item.children, ['appraisalSetting', '定额设置'])
    //   }
    //   if (item.name === 'statisticsReport' || item.label === '统计报表') {
    //     this.filterMenu(item.children, ['energyUsageStatistics', '数据报表'])
    //   }
    // }
    console.log(this.routerMenuLabel)
    const options = ['产量录入', '定额设置', '单耗分析', '数据报表']
    const gOption = []
    console.log(this.groupOptions, '----this.groupOptions')
    this.groupOptions.forEach(v => gOption.push(v))
    options.forEach(v => gOption.push(v))
    // this.routerMenuLabel.forEach(v => gOption.push(v))
    this.groupOption = _.uniq(gOption)
  }
}
</script>

<style lang="scss" scoped>
.el-dialog__wrapper {
  .el-form {
    max-height: 600px;
    overflow-y: auto;
  }
}
.dialog-form {
  padding-right: 10px;
}
</style>
